import { Directive, Output, EventEmitter } from "@angular/core";
import { NgModel } from "@angular/forms";

@Directive({
  selector: "[ngModel][inputName]",
  host: { "(input)": "onInputChange($event)" }
})
export class InputNameDirective {
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  private value: string;

  constructor(private model: NgModel) {}

  onInputChange($event) {
    let nonAlphaRegex = /[^a-zA-Z-\s]/g;
    this.value = $event.target.value.replace(nonAlphaRegex, "");
    $event.target.value = this.value;
    this.ngModelChange.emit(this.value);
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/directives/input-name.directive.ts